import Dexie from 'dexie'

const db = new Dexie('resimDb')
db.version(1).stores({
  photos: '++id, base64data'
})

export default db
